import { render } from "./trendItem.vue?vue&type=template&id=407484be&scoped=true"
import script from "./trendItem.vue?vue&type=script&lang=js"
export * from "./trendItem.vue?vue&type=script&lang=js"

import "./trendItem.vue?vue&type=style&index=0&id=407484be&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407484be"]])

export default __exports__